export const tabContainerSx = (theme) => ({
  borderBottom: 1,
  borderColor: theme.palette.secondary.main,
  backgroundColor: theme.palette.background.secondary,
});

export const tabSx = (theme) => ({
  color: theme.palette.secondary.main,
  '&:focus': {
    color: theme.palette.tertiary.main,
  },
  '&.Mui-selected': {
    color: theme.palette.tertiary.main,
  },
  minWidth: '60px',
});

export const tabPanelSx = (theme) => ({
  color: theme.palette.secondary.main,
  padding: 0,
});
